import { render, staticRenderFns } from "./DebtorPopover.vue?vue&type=template&id=4ec98731&"
import script from "./DebtorPopover.vue?vue&type=script&lang=js&"
export * from "./DebtorPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports